(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["heatmate-premium-buy"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-hm-gallery]').forEach((gallery)=>{const main=gallery.querySelector('.hm-premium__main-image');const thumbs=Array.from(gallery.querySelectorAll('[data-hm-thumb]'));const prev=gallery.querySelector('[data-hm-prev]');const next=gallery.querySelector('[data-hm-next]');if(!main||!prev||!next||thumbs.length<2)return;let index=0;const show=(nextIndex)=>{index=(nextIndex+thumbs.length)%thumbs.length;const active=thumbs[index];main.src=active.dataset.hmFull;main.srcset='';thumbs.forEach((thumb)=>thumb.classList.remove('is-active'));active.classList.add('is-active')};thumbs.forEach((thumb,thumbIndex)=>{thumb.addEventListener('click',()=>show(thumbIndex))});prev.addEventListener('click',()=>show(index-1));next.addEventListener('click',()=>show(index+1))});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
